import { Link } from "../api/api";

export class MissingLinkError extends Error {
  constructor(readonly rel: string) {
    super(`Link ${rel} not found`);
    this.name = "MissingLinkError";
  }
}

export function replaceOrigin(uri: string): string {
  const { pathname, searchParams } = new URL(uri);
  const searchString =
    searchParams.size > 0 ? `?${searchParams.toString()}` : "";
  return window.location.origin + pathname + searchString;
}

function extractRelName(link: Link): string {
  return link.rel.split("/").pop() as string;
}

export function findLink(name: string, links: Array<Link>): Link {
  const match = links.find((l) => extractRelName(l) === name);

  if (!match) {
    throw new Error(
      `Link ${name} not found in [${links.map((l) => l.rel).join(",")}]`,
    );
  }

  return match;
}

export function linkExists(name: string, links: Array<Link>): boolean {
  try {
    return findLink(name, links).href !== undefined;
  } catch {
    return false;
  }
}

export function findURIAndReplaceOrigin(
  name: string,
  links: Array<Link>,
): string {
  const uri = findLink(name, links).href;
  return replaceOrigin(uri);
}

export const findUriIfExists = (
  name: string,
  links: Array<Link>,
  externalHref = false,
): string | undefined => {
  if (linkExists(name, links)) {
    const uri = findLink(name, links).href;
    if (externalHref) return uri;
    return replaceOrigin(uri);
  }

  return undefined;
};
